<template>
<competence-cards-filters-data-provider>
	<div class="c-form  competence-cards-fitlters" slot-scope="dataProvider">
		<div class="o-grid">
			<div data-size="sm:12 md:6 lg:3" class="o-grid__column">
				<vue-input label="Filtrera på namn" 
					input-id="nameFilter" 
					ref="nameFilter" 
					type="text" 
					class="c-form__item"
					:value="dataProvider.appliedFilters.name" 
					:disabled="disabled"
					@input="dataProvider.setNameFilter"></vue-input>
			</div>
			<div data-size="sm:12 md:6 lg:3" class="o-grid__column">
				<dropdown-variations 
					:item-groups="dataProvider.competenceFilterOptions" 
					label="Filtrera på kompetensområde" 
					@selectedItem="dataProvider.setCompetenceFilter" 
					:value="(dataProvider.appliedFilters && dataProvider.appliedFilters.competence) ? dataProvider.appliedFilters.competence : {}" 
					ref="competenceFilter" 
					:filterable="true"
					:resettable="true"
					:disabled="disabled"
					></dropdown-variations>
			</div>
			<div data-size="sm:12 md:6 lg:3" class="o-grid__column">
				<dropdown-variations 
					:item-groups="dataProvider.courseFilterOptions" 
					label="Filtrera på kurskategori" 
					@selectedItem="dataProvider.setCourseFilter" 
					:value="(dataProvider.appliedFilters && dataProvider.appliedFilters.course) ? dataProvider.appliedFilters.course : {}" 
					ref="courseFilter" 
					:filterable="true"
					:resettable="true"
					:disabled="disabled"
					></dropdown-variations>
			</div>
			<div data-size="sm:12 md:6 lg:3" class="o-grid__column">
				<dropdown-variations 
					:item-groups="dataProvider.workplaceFilterOptions" 
					label="Filtrera på arbetsställe" 
					@selectedItem="dataProvider.setWorkplaceFilter" 
					:value="(dataProvider.appliedFilters && dataProvider.appliedFilters.workplace) ? dataProvider.appliedFilters.workplace : {}" 
					ref="workplaceFilter" 
					:filterable="true"
					:resettable="true"
					:disabled="disabled"
					></dropdown-variations>
			</div>
			<div data-size="sm:12" class="o-grid__column">
				<div class="t-margin-bottom-m">
					<vue-input 
						type="checkbox" 
						label="Visa endast utgående kurser/intyg"
						input-id="expiring" 
						:checked="dataProvider.appliedFilters.expiring"
						ref="expiringFilter"
						:disabled="disabled"
						@checked="dataProvider.setExpiringFilter"></vue-input>
				</div>
				<div>
					<button v-if="dataProvider.appliedFilters && dataProvider.sortDirection === 'descending'" class="c-button c-button--linkstyle c-button--reset" @click="dataProvider.setSortDirection('ascending')" id="ascending">
						<vue-icon name="arrow-down" size="c-icon--17px"></vue-icon>
						<span class="t-margin-left-xs">Sortera A-Ö</span>
					</button>
					<button v-else class="c-button c-button--linkstyle c-button--reset" @click="dataProvider.setSortDirection('descending')" id="descending">
						<vue-icon name="arrow-up" size="c-icon--17px"></vue-icon>
						<span class="t-margin-left-xs">Sortera Ö-A</span>
					</button>					
				</div>
			</div>
			<div data-size="sm:12" class="o-grid__column">
				<div v-if="dataProvider.competenceCards.length === 0 && dataProvider.anyFiltersApplied" class="t-text-align-center t-margin-top-m">
					Inga träffar, vill du <button class="c-button c-button--linkstyle c-button--reset" @click="resetAllFilters">nollställa alla filter</button>?
				</div>
			</div>
		</div>
	</div>
</competence-cards-filters-data-provider>
</template>

<script>
import CompetenceCardsFiltersDataProvider from '@/components/competences/competence-cards-filters-data-provider/CompetenceCardsFiltersDataProvider.vue';
import DropdownVariations from '@/components/vue-components/dropdown-variations/DropdownVariations.vue';
import VueInput from '@/components/vue-components/vue-input/VueInput.vue';
import VueIcon from '@/components/vue-components/vue-icon/VueIcon.vue';
export default {
    name: 'CompetenceCardsFilters',
    components: {
        CompetenceCardsFiltersDataProvider,
        DropdownVariations,
        VueInput,
        VueIcon,
	},
	props: {
		disabled: {
			type: Boolean,
			default: false
		}
	},
    methods: {
        resetAllFilters() {
            this.$refs.nameFilter.clear();
            this.$refs.competenceFilter.reset();
            this.$refs.courseFilter.reset();
            this.$refs.workplaceFilter.reset();
			this.$refs.expiringFilter.clear();
        }
    },
    created() {}
}
</script>
